module.exports = __webpack_public_path__ + "static/img/12.2d92b7db.png";